import React, { useState } from 'react'
import './UsersChatList.css'
import { Link } from 'react-router-dom'
import { Badge, Button, Modal } from 'react-bootstrap'

function UsersChatsList() {
  const [searchTerm, setSearchTerm] = useState('')
  const [show, setShow] = useState(false)
  const [selectedStatuses, setSelectedStatuses] = useState([])
  const [badges, setBadges] = useState([])
  console.log(badges)
  console.log(searchTerm)

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  const contacts = [
    {
      id: 1,
      name: 'Fleetguard Service Delay',
      phone: '+1 234 567 8901',
      organization: 'Fleetguard Filters Private Limited',
      address: '123 Main St, New York, USA',
      emoji: '😃',
      timeAgo: '3 min ago',
      tickekno: '100001',
      img: 'Whatsapp',
      ticketstatus: 'open'
    },
    {
      id: 2,
      name: 'Invoice Error',
      phone: '+44 789 654 1230',
      organization: 'Unacademy',
      address: '45 King St, London, UK',
      emoji: '😡',
      timeAgo: '7 min ago',
      tickekno: '100002',
      img: 'Facebook',
      ticketstatus: 'closed'
    },
    {
      id: 3,
      name: 'Unable to Access Portal',
      phone: '+91 99887 65432',
      organization: 'Infosys',
      address: '22 Tech Park, Bangalore, India',
      emoji: '🤔',
      timeAgo: '10 min ago',
      tickekno: '100003',
      img: 'Instagram',
      ticketstatus: 'resolved'
    },
    {
      id: 4,
      name: 'Shipping Delay',
      phone: '+34 765 432 109',
      organization: 'Amazon Spain',
      address: 'Plaza Mayor, Madrid, Spain',
      emoji: '😢',
      timeAgo: '15 min ago',
      tickekno: '100004',
      img: 'webweb',
      ticketstatus: 'closed'
    },
    {
      id: 5,
      name: 'Payment Issue',
      phone: '+81 456 789 012',
      organization: 'Rakuten',
      address: 'Shinjuku, Tokyo, Japan',
      emoji: '👍',
      timeAgo: '20 min ago',
      tickekno: '100005',
      img: 'Whatsapp',
      ticketstatus: 'open'
    },
    {
      id: 6,
      name: 'Form Submission Error',
      phone: '+33 678 543 210',
      organization: 'Coursera',
      address: '50 Rue La Fayette, Paris, France',
      emoji: '😩',
      timeAgo: '25 min ago',
      tickekno: '100006',
      img: 'Facebook',
      ticketstatus: 'closed'
    },
    {
      id: 7,
      name: 'Account Suspension',
      phone: '+1 345 678 9012',
      organization: 'Google',
      address: '1600 Amphitheatre Pkwy, Mountain View, USA',
      emoji: '😱',
      timeAgo: '30 min ago',
      tickekno: '100007',
      img: 'Instagram',
      ticketstatus: 'open'
    },
    {
      id: 8,
      name: 'Refund Request',
      phone: '+91 98765 43210',
      organization: 'Flipkart',
      address: '21 MG Road, Delhi, India',
      emoji: '❤️',
      timeAgo: '35 min ago',
      tickekno: '100008',
      img: 'webweb',
      ticketstatus: 'closed'
    },
    {
      id: 9,
      name: 'Feature Request',
      phone: '+55 789 654 123',
      organization: 'Spotify',
      address: 'Paulista Ave, São Paulo, Brazil',
      emoji: '🎶',
      timeAgo: '40 min ago',
      tickekno: '100009',
      img: 'Whatsapp',
      ticketstatus: 'open'
    },
    {
      id: 10,
      name: 'Broken Link',
      phone: '+61 987 654 321',
      organization: 'Atlassian',
      address: '200 George St, Sydney, Australia',
      emoji: '💔',
      timeAgo: '45 min ago',
      tickekno: '100010',
      img: 'Facebook',
      ticketstatus: 'closed'
    },
    {
      id: 11,
      name: 'Data Sync Issue',
      phone: '+49 456 789 123',
      organization: 'SAP',
      address: 'Walldorf, Germany',
      emoji: '🔄',
      timeAgo: '50 min ago',
      tickekno: '100011',
      img: 'Instagram',
      ticketstatus: 'open'
    },
    {
      id: 12,
      name: 'Password Reset',
      phone: '+39 987 654 123',
      organization: 'Coursera',
      address: 'Piazza del Duomo, Milan, Italy',
      emoji: '🔑',
      timeAgo: '55 min ago',
      tickekno: '100012',
      img: 'webweb',
      ticketstatus: 'closed'
    },
    {
      id: 13,
      name: 'Login Issue',
      phone: '+82 345 678 901',
      organization: 'Samsung',
      address: 'Samsung Town, Seoul, South Korea',
      emoji: '😓',
      timeAgo: '60 min ago',
      tickekno: '100013',
      img: 'Whatsapp',
      ticketstatus: 'open'
    },
    {
      id: 14,
      name: 'Mobile App Crash',
      phone: '+971 654 789 012',
      organization: 'Careem',
      address: 'Sheikh Zayed Rd, Dubai, UAE',
      emoji: '📱',
      timeAgo: '65 min ago',
      tickekno: '100014',
      img: 'Facebook',
      ticketstatus: 'closed'
    },
    {
      id: 15,
      name: 'API Timeout',
      phone: '+1 456 789 123',
      organization: 'AWS',
      address: '410 Terry Ave, Seattle, USA',
      emoji: '🌐',
      timeAgo: '70 min ago',
      tickekno: '100015',
      img: 'Instagram',
      ticketstatus: 'open'
    },
    {
      id: 16,
      name: 'Overcharged',
      phone: '+91 98765 43211',
      organization: 'Zomato',
      address: '100 Brigade Rd, Bangalore, India',
      emoji: '🍔',
      timeAgo: '75 min ago',
      tickekno: '100016',
      img: 'webweb',
      ticketstatus: 'closed'
    },
    {
      id: 17,
      name: 'Invoice Not Found',
      phone: '+86 123 456 789',
      organization: 'Alibaba',
      address: 'Hangzhou, China',
      emoji: '📄',
      timeAgo: '80 min ago',
      tickekno: '100017',
      img: 'Whatsapp',
      ticketstatus: 'open'
    },
    {
      id: 18,
      name: 'Account Hacked',
      phone: '+91 12345 67890',
      organization: 'Paytm',
      address: 'Noida, India',
      emoji: '🛡️',
      timeAgo: '85 min ago',
      tickekno: '100018',
      img: 'Facebook',
      ticketstatus: 'closed'
    },
    {
      id: 19,
      name: 'Subscription Issue',
      phone: '+44 678 123 456',
      organization: 'Netflix',
      address: '10 Soho Sq, London, UK',
      emoji: '🎥',
      timeAgo: '90 min ago',
      tickekno: '100019',
      img: 'Instagram',
      ticketstatus: 'open'
    },
    {
      id: 20,
      name: 'Server Downtime',
      phone: '+1 234 567 890',
      organization: 'Azure',
      address: 'One Microsoft Way, Redmond, USA',
      emoji: '⚙️',
      timeAgo: '95 min ago',
      tickekno: '100020',
      img: 'webweb',
      ticketstatus: 'closed'
    }
  ]

  // Function to toggle statuses
  const toggleStatus = status => {
    setSelectedStatuses(prev =>
      prev.includes(status) ? prev.filter(s => s !== status) : [...prev, status]
    )
  }

  // Filter logic
  const filteredContacts = contacts.filter(contact => {
    const matchesSearch =
      contact.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      contact.tickekno.includes(searchTerm) ||
      contact.phone.replace(/\s+/g, '').includes(searchTerm.replace(/\s+/g, ''))

    const matchesStatus =
      selectedStatuses.length === 0 ||
      selectedStatuses.includes(contact.ticketstatus)

    return matchesSearch && matchesStatus
  })

  // const handleSearch = event => {
  //   setSearchTerm(event.target.value)
  // }

  const handleInputChange = e => {
    const value = e.target.value

    // Check if Backspace is pressed and input is empty
    if (e.key === 'Backspace' && !value && badges.length > 0) {
      removeBadge(badges.length - 1) // Remove the last badge
      return // Exit the function to avoid further processing
    }

    // Check for a space or Enter key to create a badge
    if (value.includes(' ') || e.key === 'Space' || e.key === 'Enter') {
      const trimmed = value.trim()
      if (trimmed.startsWith('#') && trimmed.length > 1) {
        setBadges([...badges, trimmed])
      }
      setSearchTerm('') // Clear the input
    } else {
      setSearchTerm(value) // Update the input value
      console.log(value)
    }
  }

  const removeBadge = index => {
    setBadges(badges.filter((_, i) => i !== index))
  }

  return (
    <>
      <div className="UserChatView ">
        <div className="UserChatHeader">
          {/* Searchbox */}
          <div className="wide-block pt-1 pb-1 pe-0 position-sticky searchSection ">
            <form className="search-form badge-input-container">
              <div className="form-group searchbox not-empty ">
                <div className="badge-list">
                  {badges.map((badge, index) => (
                    <span key={index} className="s-badge">
                      {badge}
                      <button
                        type="button"
                        className="badge-remove"
                        onClick={() => removeBadge(index)}
                      >
                        &times;
                      </button>
                    </span>
                  ))}
                </div>
                <input
                  type="text"
                  className="form-control px-2"
                  placeholder="Search Conversations"
                  value={searchTerm}
                  onChange={handleInputChange}
                  onKeyDown={handleInputChange}
                />
                {/* <i className="input-icon">
                <ion-icon
                  name="search-outline"
                  role="img"
                  className="md hydrated"
                  aria-label="search outline"
                ></ion-icon>
              </i> */}
              </div>
            </form>
          </div>
          {/* Searchbox */}

          {/* chips */}
          <div
            className="d-flex gap-2  my-2"
            style={{
              overflowX: 'auto',
              scrollbarWidth: 'none',
              paddingBottom: ' .5rem',
              paddingLeft: '20px',
              paddingRight: '20px',
              borderBottom: '1px solid #e1e1e1'
            }}
          >
            <input
              type="checkbox"
              className="btn-check"
              name="btnradiof"
              id="btnradioq1"
              checked={!selectedStatuses.includes('All')}
              // onChange={() => toggleStatus('')}
            />
            <label
              className="btn btn-outline-primary btn-chip"
              htmlFor="btnradioq1"
            >
              All
            </label>
            <input
              type="checkbox"
              className="btn-check"
              name="btnradiof"
              id="btnradioq2"
              checked={selectedStatuses.includes('open')}
              onChange={() => toggleStatus('open')}
            />
            <label
              className="btn btn-outline-success btn-chip"
              htmlFor="btnradioq2"
            >
              Open
            </label>

            <input
              type="checkbox"
              className="btn-check"
              name="btnradiof"
              id="btnradioq3"
              checked={selectedStatuses.includes('closed')}
              onChange={() => toggleStatus('closed')}
            />
            <label
              className="btn btn-outline-danger btn-chip"
              htmlFor="btnradioq3"
            >
              Closed
            </label>

            <input
              type="checkbox"
              className="btn-check"
              name="btnradiof"
              id="btnradioq4"
              checked={selectedStatuses.includes('resolved')}
              onChange={() => toggleStatus('resolved')}
            />
            <label
              className="btn btn-outline-warning btn-chip"
              htmlFor="btnradioq4"
            >
              Resolved
            </label>
          </div>
          {/* chips */}
        </div>

        {/* ticketchat */}
        <div className="UsersChats ListView">
          <ul className="listview image-listview">
            {filteredContacts.map(contact => (
              <li key={contact.id}>
                <Link
                  to={`?chatId=${contact.tickekno}`}
                  className="item active"
                >
                  <div className="d-flex justify-content-start align-items-center">
                    <div className="d-flex justify-content-start me-1">
                      <Badge bg="secondary">#{contact.tickekno}</Badge>
                    </div>
                    <div className="d-flex justify-content-start flex-wrap flex-column">
                      <div className="ticket-name">{contact.name}</div>
                      <header>
                        {contact.organization}
                        <span className="timeAgo">{contact.timeAgo}</span>
                        &nbsp;
                      </header>
                    </div>
                    <div
                      className="d-flex justtify-content-end"
                      style={{ position: 'absolute', right: '35px' }}
                    >
                      {contact.ticketstatus === 'open' && (
                        <span className="badge bg-success">
                          {contact.ticketstatus}
                        </span>
                      )}
                      {contact.ticketstatus === 'closed' && (
                        <span className="badge bg-danger">
                          {contact.ticketstatus}
                        </span>
                      )}
                      {contact.ticketstatus === 'resolved' && (
                        <span className="badge bg-warning">
                          {contact.ticketstatus}
                        </span>
                      )}
                    </div>
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        </div>
        {/* ticketchat */}

        {/* fab */}
        <div class="fab-button text bottom-center ">
          <a
            href="#"
            class="fab px-3"
            style={{ height: '40px' }}
            onClick={handleShow}
          >
            <ion-icon
              name="add-outline"
              style={{ marginTop: '2.7px' }}
            ></ion-icon>
            New ticket
          </a>
          <Modal centered backdrop="static" show={show} onHide={handleClose}>
            <Modal.Header closeButton style={{ borderBottom: '0' }}>
              <Modal.Title>Lookup or create a user</Modal.Title>
            </Modal.Header>
            <Modal.Body className="pe-0 mx-4">
              <form>
                <div class="form-group boxed">
                  <div class="input-wrapper">
                    <label class="form-label" for="name5">
                      Name
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="name5"
                      placeholder="Enter your name"
                      autocomplete="off"
                    />
                    <i class="clear-input">
                      <ion-icon name="close-circle"></ion-icon>
                    </i>
                  </div>
                </div>

                <div class="form-group boxed">
                  <div class="input-wrapper">
                    <label class="form-label" for="email5">
                      E-mail
                    </label>
                    <input
                      type="email"
                      class="form-control"
                      id="email5"
                      placeholder="E-mail address"
                      autocomplete="off"
                    />
                    <i class="clear-input">
                      <ion-icon name="close-circle"></ion-icon>
                    </i>
                  </div>
                </div>

                <div class="form-group boxed">
                  <div class="input-wrapper">
                    <label class="form-label" for="city5">
                      City
                    </label>
                    <select class="form-control form-select" id="city5">
                      <option value="0">Select a city</option>
                      <option value="1">New York City</option>
                      <option value="2">Austin</option>
                      <option value="3">Colorado</option>
                    </select>
                  </div>
                </div>

                <div class="form-group boxed">
                  <div class="input-wrapper">
                    <label class="form-label" for="password5">
                      Password
                    </label>
                    <input
                      type="password"
                      class="form-control"
                      id="password5"
                      placeholder="Type a password"
                      autocomplete="off"
                    />
                    <i class="clear-input">
                      <ion-icon name="close-circle"></ion-icon>
                    </i>
                  </div>
                </div>

                <div class="form-group boxed">
                  <div class="input-wrapper">
                    <label class="form-label" for="phone5">
                      Phone
                    </label>
                    <input
                      type="tel"
                      class="form-control"
                      id="phone5"
                      placeholder="Enter your phone number"
                    />
                    <i class="clear-input">
                      <ion-icon name="close-circle"></ion-icon>
                    </i>
                  </div>
                </div>

                <div class="form-group boxed">
                  <div class="input-wrapper">
                    <label class="form-label" for="address5">
                      Address
                    </label>
                    <textarea
                      id="address5"
                      rows="2"
                      class="form-control"
                    ></textarea>
                    <i class="clear-input">
                      <ion-icon name="close-circle"></ion-icon>
                    </i>
                  </div>
                </div>
              </form>
            </Modal.Body>
            <Modal.Footer style={{ borderTop: '0' }}>
              <Button variant="secondary" onClick={handleClose}>
                Close
              </Button>
              <Button variant="primary" onClick={handleClose}>
                Save Changes
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
        {/* fab */}
      </div>
    </>
  )
}

export default UsersChatsList
